import { useEffect, useState } from "react";

const DAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

export const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const fmtTime = (t) => {
  const [h, m] = t.split(":").map(Number);
  if (h === 0 && m === 0) return "12:00 AM";
  const suffix = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${suffix}`;
};

export function nyNow(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type).value;
  return { day: DAY_INDEX[get("weekday")], min: (Number(get("hour")) % 24) * 60 + Number(get("minute")) };
}

const overnight = (h) => !h.closed && toMin(h.close) <= toMin(h.open);

export function getOpenStatus(hours, date) {
  if (!hours?.length) return { open: false };
  const { day, min } = nyNow(date);
  const today = hours[day];
  const yesterday = hours[(day + 6) % 7];
  if (yesterday && overnight(yesterday) && min < toMin(yesterday.close)) {
    return { open: true, until: yesterday.close };
  }
  if (today && !today.closed && min >= toMin(today.open) && (overnight(today) || min < toMin(today.close))) {
    return { open: true, until: today.close };
  }
  if (today && !today.closed && min < toMin(today.open)) {
    return { open: false, opensAt: today.open, opensDay: "today" };
  }
  for (let i = 1; i <= 7; i += 1) {
    const h = hours[(day + i) % 7];
    if (h && !h.closed) return { open: false, opensAt: h.open, opensDay: i === 1 ? "tomorrow" : h.day };
  }
  return { open: false };
}

export function useOpenStatus(hours) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);
  return getOpenStatus(hours, now);
}

export const dayRange = (h) => (h.closed ? "Closed" : `${fmtTime(h.open)} – ${fmtTime(h.close)}`);

export function groupHours(hours) {
  const groups = [];
  hours.forEach((h) => {
    const label = dayRange(h);
    const last = groups[groups.length - 1];
    if (last && last.label === label) {
      last.to = h.day;
    } else {
      groups.push({ from: h.day, to: h.day, label });
    }
  });
  return groups.map((g) => ({ days: g.from === g.to ? g.from : `${g.from} – ${g.to}`, label: g.label }));
}
